import { ReactElement } from 'react'

import ComprovanteTransferenciaImpl from 'modules/pagamentos/domain/usecases/ComprovanteTransferencia'
import TransferenciaContaBancariaImpl from 'modules/pagamentos/domain/usecases/TransferenciaContaBancaria'
import TransferenciaTmovPayImpl from 'modules/pagamentos/domain/usecases/TransferenciaTmovPay'
import PagamentoRepository from 'modules/pagamentos/infra/repositories/PagamentoRepository'
import TransferenciaRepository from 'modules/pagamentos/infra/repositories/TransferenciaRepository'
import Confirmacao from 'modules/pagamentos/pages/components/Transferir/components/Confirmacao'
import EnviarPinTmovPayImpl from 'modules/pagamentos/domain/usecases/EnviarPinTmovPay'
import ValidarPinTmovPayImpl from 'modules/pagamentos/domain/usecases/ValidarPinTmovPay'
import VerifyPasswordImpl from 'modules/pagamentos/domain/usecases/VerifyPassword'

export const ConfirmaTransferenciaFactory = (): ReactElement => {
  const transferenciaRepository = new TransferenciaRepository()
  const pagamentoRepository = new PagamentoRepository()
  const transferenciaTmovPay = new TransferenciaTmovPayImpl(pagamentoRepository)
  const transferenciaContaBancaria = new TransferenciaContaBancariaImpl(
    pagamentoRepository,
  )
  const comprovanteTransferenciaImpl = new ComprovanteTransferenciaImpl(
    transferenciaRepository,
  )
  const enviarPinTmovPay = new EnviarPinTmovPayImpl(pagamentoRepository)
  const validarPinTmovPay = new ValidarPinTmovPayImpl(pagamentoRepository)
  const verifyPassword = new VerifyPasswordImpl(pagamentoRepository)

  return (
    <Confirmacao
      transferenciaTmovPay={transferenciaTmovPay}
      transferenciaContaBancaria={transferenciaContaBancaria}
      comprovanteTransferencia={comprovanteTransferenciaImpl}
      enviarPinTmovPay={enviarPinTmovPay}
      validarPinTmovPay={validarPinTmovPay}
      verifyPassword={verifyPassword}
    />
  )
}
